export const SHOW_EDIT_CUSTOMER_SLIDEOUT = 'SHOW_EDIT_CUSTOMER_SLIDEOUT';
export const HIDE_EDIT_CUSTOMER_SLIDEOUT = 'HIDE_EDIT_CUSTOMER_SLIDEOUT';
export const BUYER = 'buyer';
export const CO_BUYER = 'coBuyer';
export const INSURANCE = 'insurance';

export const SET_CUSTOMER_TO_SYNC = 'SET CUSTOMER TO SYNC';
export const REMOVE_CUSTOMER_FROM_SYNC = 'REMOVE CUSTOMER FROM SYNC';
export const SYNC_CUSTOMER_REQUEST = 'SYNC_CUSTOMER_REQUEST';
export const SYNC_CUSTOMER_SUCCESS = 'SYNC_CUSTOMER_SUCCESS';
export const SYNC_CUSTOMER_FAILURE = 'SYNC_CUSTOMER_FAILURE';

export const CREATE_BUSINESS_REQUEST = 'CREATE_BUSINESS_REQUEST';
export const CREATE_BUSINESS_SUCCESS = 'CREATE_BUSINESS_SUCCESS';
export const CREATE_BUSINESS_FAILURE = 'CREATE_BUSINESS_FAILURE';
export const CLEAR_CREATE_BUSINESS_ERROR = 'CLEAR_CREATE_BUSINESS_ERROR';

export const SHOW_BUSINESS_SEARCH = 'SHOW_BUSINESS_SEARCH';
export const HIDE_BUSINESS_SEARCH = 'HIDE_BUSINESS_SEARCH';
export const BUSINESS_SEARCH_REQUEST = 'BUSINESS_SEARCH_REQUEST';
export const BUSINESS_SEARCH_SUCCESS = 'BUSINESS_SEARCH_SUCCESS';
export const BUSINESS_SEARCH_FAILURE = 'BUSINESS_SEARCH_FAILURE';
export const CLEAR_BUSINESS_SEARCH_RESULTS = 'CLEAR_BUSINESS_SEARCH_RESULTS';
export const SELECT_BUSINESS_RESULT = 'SELECT_BUSINESS_RESULT';

export const ASSOCIATE_BUSINESS_REQUEST = 'ASSOCIATE_BUSINESS_REQUEST';
export const ASSOCIATE_BUSINESS_SUCCESS = 'ASSOCIATE_BUSINESS_SUCCESS';
export const ASSOCIATE_BUSINESS_FAILURE = 'ASSOCIATE_BUSINESS_FAILURE';
export const CLEAR_ASSOCIATE_BUSINESS_ERROR = 'CLEAR_ASSOCIATE_BUSINESS_ERROR';
